import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-last-update',
  templateUrl: './last-update.component.html',
  styleUrls: ['./last-update.component.scss'],
})
export class LastUpdateComponent implements OnInit {
  public lastUpdateDate: string;
  public isConnected = true;
  tooltipIsVisible: boolean;
  public isModalResumenOpen = false;
  @Output() actualizarExamenes: EventEmitter<any> = new EventEmitter<any>();
  @Output() actualizarAgendas: EventEmitter<any> = new EventEmitter<any>();
  @Input() mostrarMensajeDeFiltrosActivos: boolean;
  @Input() isAgenda: boolean;
  habilitarResumen = false;


  constructor(private connectionService: ConnectionService) {
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isConnected = connected.hasNetworkConnection;;
    });
  }

  ngOnInit(): void {
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    this.isConnected = !!isOnline;
    this.buildLastUpdateDate();

    if(isOnline){
      this.habilitarResumen = true;
    }
  }

  updateExams(): void {
    if (this.isConnected) {
      this.actualizarExamenes.emit(true);
      this.buildLastUpdateDate();
    }
  }

  updateAgendas(): void {
    if (this.isConnected) {
      this.actualizarAgendas.emit(true);
    }
  }

  buildLastUpdateDate(): void {
    const lastUpdate = new Date();
    this.lastUpdateDate = lastUpdate.getDate().toString();
    const month = lastUpdate.toLocaleString('es', { month: 'short' });
    this.lastUpdateDate += ` ${
      month.charAt(0).toUpperCase() + month.slice(1)
    } `;
    let minutes = '0';
    if (lastUpdate.getMinutes() < 10) {
      minutes += lastUpdate.getMinutes();
    } else {
      minutes = lastUpdate.getMinutes().toString();
    }
    this.lastUpdateDate += `${lastUpdate
      .getFullYear()
      .toString()}, ${lastUpdate.getHours()}:${minutes} h.`;
  }

  mouseEnter(): void {
    if (!this.isConnected) {
      this.tooltipIsVisible = true;
    }
  }

  mouseLeave(): void {
    this.tooltipIsVisible = false;
  }

  openModalResumen(): void {
    if (this.isConnected) {
      this.isModalResumenOpen = true;
      }
  }

  closeModalResumen(): void {
    this.isModalResumenOpen = false;
  }
}
